import { render, staticRenderFns } from "./InventorySummary.vue?vue&type=template&id=00ab635a&"
import script from "./InventorySummary.vue?vue&type=script&lang=js&"
export * from "./InventorySummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports